module.exports = __webpack_public_path__ + "img/isi-certified-4-400-compressed.1584aec8.png";